export enum FactType {
    Score = "SCORE",
    Serve = "SERVE",
    Corners = "CORNERS",
    YellowCards = "YELLOW_CARDS",
    RedCards = "RED_CARDS",
    DisplayScore = "DISPLAY_SCORE",
    MaxSets = "MAX_SETS",
    DestroyedTurrets = "DESTROYED_TURRETS",
    Gold = "GOLD",
    Kills = "KILLS",
    RoundsWon = "ROUNDS_WON",
    TeamDescriptor = "TEAM_DESCRIPTOR",
    CurrentRound = "CURRENT_ROUND",
    DestroyedTowers = "DESTROYED_TOWERS",
}
